import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { HairFallMaleRegimenBannerComponentComponent } from './hair-fall-male.component';

@NgModule({
  declarations: [HairFallMaleRegimenBannerComponentComponent],
  imports: [
    CommonModule,
    CsIconModule,
  ],
  exports: [HairFallMaleRegimenBannerComponentComponent],
})

export class HairFallMaleBannerModule { }
